<template>

  <section
      :id="(section.properties) ? section.properties['v-section-id'] : ''"
      v-bind="section.bg"
  >
    <div class="m360-video-bg" v-if="section.background && section.background.video">
      <video v-bind="section.background.video.properties" playsinline>
        <source :src="section.background.video.media.src" :type="section.background.video.media.type">
        Your browser does not support the video tag.
      </video>
    </div>
    <v-container v-bind="section.properties">
      <template
          v-for="(element, index) in section.elements"
      >
        <dynamic-row
            :class="{'m360-above-video-bg': (section.background && section.background.video) }"
            :key="index"
            v-if="element.vuetify ==='v-row'"
            :row="element"
        ></dynamic-row>

        <v-divider
            :key="index"
            v-else-if="element.vuetify ==='v-divider'"
            v-bind="element.properties"
        />

        <template v-else-if="element.vuetify === 'dynamic-abstract'">
          <dynamic-abstract
              :key="index"
              :context="element"
          />
        </template>
      </template>
    </v-container>

  </section>
</template>
<script>

import DynamicRow   from "@/components/DynamicRow";
import globalMixins from "@/mixins/globalMixins";

export default {
  name: 'DynamicSection',
  props: {
    context: {
      type: Object
    }
  },

  data() {
    return {
      section: {
        bg: {}
      }
    }
  },

  mixins: [ globalMixins ],

  components: {
    DynamicRow
  },

  async created() {
    this.section = this._.cloneDeep( this.context );
    this.checkFixProperties( this.section, true );
    await this.checkSetElementBackground( this.section , true);

    if(!this.section.properties.class){
      this.section.properties.class = '';
    }

    this.section.properties.class = 'py-0 ' + this.section.properties.class;
    // if(this.section.bg){
    //   this.section.properties.style = this._.merge(this.section.properties.style, this.section.bg.style);
    //   this.section.properties.class = `${this.section.bg.class} ${this.section.properties.class}`;
    // }

    // if(!this.section.properties.style){
    //   this.section.properties.style = {};
    // }
    // if(this.section.properties.fluid){
    //   this.section.properties.style['width'] = '100%';
    // }
    // else{
    //   if(!this.section.properties.style['max-width']){
    //     let selectedTheme = this.$vuetify.theme.isDark ? 'dark': 'light';
    //     let spacer = this.$vuetify.theme.defaults[selectedTheme].spacer;
    //     let variant = this.$vuetify.theme.defaults[selectedTheme]['spacers-steps'];
    //     this.section.properties.style['max-width'] = ( this.$vuetify.breakpoint.width - (spacer * variant) ) + 'px';
    //     this.section.properties.style['margin-left'] = 'auto';
    //     this.section.properties.style['margin-right'] = 'auto';
    //   }
    // }

    this.$nextTick(()=>{
      this.$forceUpdate();
    })
  }
}
</script>
<style>
.m360-relative-section {
  position: relative;
  overflow: hidden;
}
.m360-above-video-bg{
  position:relative;
  z-index: 1;
}

.m360-video-tag,
.m360-video-bg {
  position: absolute;
  width:100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  overflow: hidden;
  z-index: 0;
}


</style>